import { Context, createContext, useContext } from 'react';

import type { GraphqlClient } from './data-client';

const gqlClientContext = createContext<GraphqlClient>(null as any);

export { gqlClientContext };

export type { Context };

export function useGqlClient(): GraphqlClient {
  const client = useContext(gqlClientContext);
  if (!client) {
    throw new Error('context must be used within a GqlClientProvider');
  }
  return client;
}
